module.exports = __webpack_public_path__ + "static/media/livecasino-icon.720c9d0a.svg";